import React, { useRef, useEffect } from "react";
import { Card, CardMedia, Button } from "@mui/material";
import img2 from "./../../assets/images/taylor2.jpg";
import img3 from "./../../assets/images/taylor3.jpg";
import img4 from "./../../assets/images/selena1.jpg";
import img5 from "./../../assets/images/selena2.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import useResize from "./../../hooks/resize";
import ListView from "../../components/ListView/ListView";
import SongCard from "../../components/SongCard/SongCard";
import Scrollbar from "smooth-scrollbar";
import { Link, MenuItemLink } from "react-admin";
import AlbumCard from "../../common/components/AlbumCard/AlbumCard";

const images = [
  img2,
  img3,
  img4,
  img5,
  img2,
  img3,
  img2,
  img3,
  img4,
  img2,
  img3,
  img4,
];
export default function Home() {
  const device = useResize("");
  const scrollContainer = useRef(null);
  const slidePerView = {
    desktop: 5,
    laptop: 4,
    tablet: 3,
    mobile: 2,
    smallMobile: 1,
  };
  console.log("device", device);
  useEffect(() => {
    if (
      device === "mobile" ||
      device === "smallMobile" ||
      device === "tablet"
    ) {
      console.log("scroll if", device);
      Scrollbar.destroy(scrollContainer.current);
      Scrollbar.init(scrollContainer.current, {
        alwaysShowTracks: true,
        damping: 1,
      });
    } else {
      Scrollbar.destroy(scrollContainer.current);
      Scrollbar.init(scrollContainer.current, {
        alwaysShowTracks: true,
        damping: 0.1,
      });
    }
  }, [device]);
  useEffect(() => {
    Scrollbar.init(scrollContainer.current, {
      alwaysShowTracks: true,
    });
  }, []);
  return (
    <div ref={scrollContainer} style={{ height: "100%" }}>
      <div className="home" style={{ width: "100%", height: "100%" }}>
        <ListView
          title="Recent Albums"
          subTitle={"2021: 19/12"}
          listData={[0, 0, 0, 0, 0, 0, 0, 0]}
          action={<Button>SeeAll</Button>}
          spaceBetween={8}
          devices={{
            desktop: 4,
            laptop: 3,
            tablet: 2,
            mobile: 1,
            smallMobile: 1,
          }}
          elements={(data) => {
            return data.map((item, i) => (
              <AlbumCard
                style={{ height: "100%", color: "white" }}
                imgUrl={images[i]}
              />
            ));
          }}
          direction="horizontal"
          slidesPerView={4}
          spaceBetween={1}
          style={{
            ...listViewStyle,
            root: { ...listViewStyle.root, margin: 0, padding: 0 },
            action: {
              ...listViewStyle.action,
              position: "absolute",
              left: "100%",
              top: "100%",
              transform: "translate(-150%,-150%)",
            },
          }}
        />
        <ListView
          title="Single and EPs"
          direction="horizontal"
          devices={{
            desktop: 5,
            laptop: 4,
            tablet: 3,
            mobile: 2,
            smallMobile: 2,
          }}
          slidesPerView={5}
          style={{
            ...listViewStyle,
            root: { paddingTop: "12px" },
            scrollContent: { marginBottom: 0 },
          }}
          action={<Button>See All</Button>}
          listData={[0, 0, 0, 0, 0, 0, 0]}
          elements={(data) => {
            return data.map((item, i) => {
              return (
                <SongCard
                  img={images[i]}
                  style={{
                    height: "100%",
                    borderRadius: "7px",
                  }}
                />
              );
            });
          }}
        />

        <ListView
          title={"Featuring Hava"}
          subTitle={"subtitle"}
          action={<Link to="see-all">See all</Link>}
          direction="horizontal"
          slidesPerView={5}
          devices={{
            desktop: 5,
            laptop: 4,
            tablet: 3,
            mobile: 2,
            smallMobile: 2,
          }}
          style={{ ...listViewStyle }}
          listData={[0, 0, 0, 0, 0, 0, 0]}
          elements={(data) => {
            return data.map((item, i) => {
              return (
                <SongCard img={images[i]} style={{ height: "100%" }}></SongCard>
              );
            });
          }}
        />
      </div>
    </div>
  );
}
const listViewStyle = {
  root: { paddingTop: "80px" },
  scrollContent: {
    width: "100%",
    height: "269px",
    marginBottom: "88px",
  },
  header: { position: "relative" },
  title: {
    fontSize: "22px",
    marginLeft: "16px",
    position: "relative",
    top: "10px",
  },
  subTitle: { color: "gray", marginLeft: "16px" },
  action: {
    minWidth: "80px",
    width: "max-content",
    position: "absolute",
    top: "100%",
    left: "100%",
    transform: "translate(-120%,-50%)",
    paddingRight: "22px",
    whiteSpace: "no-wrap",
  },
};
